//External imports
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate } from '@angular/service-worker';
import { AlertService } from '@shared/services/alert.service';
import { filter, interval } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ServiceWorkerService {
    updates = inject(SwUpdate);
    private alertService = inject(AlertService);

    private destroyRef = inject(DestroyRef);

    constructor() {
        if (this.updates?.isEnabled) {
            this.updates.versionUpdates
                .pipe(
                    filter((event) => event.type === 'VERSION_READY'),
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(() => this.promptUser());

            this.updates.checkForUpdate();
            interval(2 * 60 * 1000)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                    this.updates.checkForUpdate();
                });
        }
    }

    /*
     * function is used for reload application when new version is available
     */
    public promptUser(): void {
        this.updates?.activateUpdate()?.then(() => {
            this.alertService.confirm('Update Available', 'A new version of the application is available. Do you want to update?', 'Update', 'Later').then((result) => {
                if (result.isConfirmed) window.location.reload();
            });
        });
    }

    /*
     * function is used for clear cache in existing browser applicatin -> storage -> cache storage and it clear our load website only
     * it is not clear local storage data or session storage data
     */
    public clearExistingBrowserCache() {
        caches?.keys()?.then((names) => {
            for (const name of names) {
                caches?.delete(name); //delete existing cache details
            }
        });
    }
}
